export default "__VITE_ASSET__ica5X0rh__"